import React from "react";
import "./homeSections.css";

const WhyChooseUs = () => {
  return (
    <section className="home-section why-section">
      <div className="container">

        <h2>Why Choose ShareVideo?</h2>

        <p>
          ShareVideo is designed to support modern digital creators by offering
          a flexible, multi-format publishing platform. Whether you create
          videos, short clips, music, audio songs, or photo posts, our system
          provides the tools needed to grow and monetize your audience.
        </p>

        <div className="why-grid">

          <div className="why-item">
            <h3>Multi-Format Content Support</h3>
            <p>
              Upload full-length videos, short vertical content, music videos,
              standalone audio tracks, and image-based posts � all in one
              platform without format restrictions.
            </p>
          </div>

          <div className="why-item">
            <h3>Creator-Focused Dashboard</h3>
            <p>
              Manage uploads, monitor impressions, and track engagement
              through a simple and easy-to-use creator dashboard built
              for performance and clarity.
            </p>
          </div>

          <div className="why-item">
            <h3>Impression-Based Earnings</h3>
            <p>
              Our monetization system rewards creators based on visibility
              and engagement. High-quality and original content is promoted
              to ensure fair growth opportunities.
            </p>
          </div>

          <div className="why-item">
            <h3>Content Discovery System</h3>
            <p>
              Videos, shorts, songs, and photo posts are discoverable through
              homepage sections, category listings, and recommendation feeds,
              helping creators reach a broader audience.
            </p>
          </div>

          <div className="why-item">
            <h3>Safe & Responsible Platform</h3>
            <p>
              We maintain community guidelines and copyright standards to
              ensure a safe, respectful, and policy-compliant content
              environment for viewers and creators.
            </p>
          </div>

          <div className="why-item">
            <h3>Free & Accessible</h3>
            <p>
              Creating an account and publishing content on ShareVideo is
              free, making it accessible to independent creators looking
              to grow their digital presence.
            </p>
          </div>

        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;